<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="responsive">
  <BackgroundImage />

    <div id="wrapper">
      <div id="head-logo">
        <router-link to="/pc/login" target="_blank">
          <img src="/lc/app/images/log-1row.svg" alt="LEGAL CONNECTION">
        </router-link>
      </div>
      <!-- content:start -->
      <div id="content">
        <div class="contact">
          <div class="contact-head">
            <div class="breadcrumb">
              <span class="breadcrumb-link">お問い合わせ</span>
              <span class="breadcrumb-link">お問い合わせ内容の確認</span>
              <span class="breadcrumb-link current">お問い合わせ受付の完了</span>
            </div>
            <h1 class="hdg02">お問い合わせ受付の完了</h1>
            <a href="/lc/about/" target="_blank" class="contact-head-link">LEGAL CONNECTIONについて <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
          </div>
          <div class="contact-container">
            <div class="contact-content">
              <p class="txt mb40">お問い合わせの受付が完了しました。<br>
              ご入力いただいたメールアドレスにお問い合わせ内容の確認メールを送信しておりますのでご確認ください。<br>
              弊社担当よりあらためてご連絡いたします。</p>
              
              <div class="contact-submit mb40">
                <div class="button contact-submit-button">
                  <router-link class="btn" target="_blank" to="/pc/login">ログイン画面へ</router-link>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
// import '@/components/style/RESCommonCSS.vue'

import * as logicInquiry from '@/logic/public/Inquiry.js'

export default defineComponent({
  components: {
  },
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicInquiry.getGroupComplete()

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>

</style>
